import { Node, NodeViewProps, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import type { ConversationMessagePersona } from '@duke-hq/ui/components/Conversation/ConversationMessage';

import { DBlockNodeViewStudent } from './DBlockNodeViewStudent';

export interface DBlockOptions {
  HTMLAttributes: Record<string, unknown>;
  getPersonaById: (personaId: string) => ConversationMessagePersona;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    dBlock: {
      /**
       * Toggle a dBlock
       */
      setDBlock: (position?: number) => ReturnType;
    };
  }
}

export const StudentDBlockExtension = Node.create<DBlockOptions>({
  name: 'dBlock',

  group: 'block',

  content: 'block+',

  addAttributes() {
    return {
      personaId: {},
      // Grouping flags computed against the full block sequence when the
      // document is (re)built, so they stay correct as later same-speaker blocks
      // are appended (a NodeView reading live editor state wouldn't re-evaluate
      // an already-rendered block).
      showName: { default: true },
      showAvatar: { default: true },
      animation: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-animation'),
        renderHTML: (attributes) => {
          return {
            'data-animation': attributes.animation,
          };
        },
      },
      animationIndex: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-animation-index'),
        renderHTML: (attributes) => {
          return {
            'data-animation-index': attributes.animationIndex,
          };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="d-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'd-block' }), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer((props: NodeViewProps) => (
      <DBlockNodeViewStudent {...props} {...this.options} />
    ));
  },
});
